<template>
  <div
    v-if="savingsInPercent"
    :class="[
      'price-savings-in-percent-fi',
      theme ? `price-savings-in-percent-fi--theme-${theme}` : '',
    ]"
  >
    <span class="badge-fi">
      {{ savingsInPercent }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'PriceSavingsInPercentFi',
  props: {
    bestPrice: {
      type: Object,
      default: () => ({}),
    },
    small: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },
  computed: {
    quantity() {
      let qty = 0;
      if (this.bestPrice) {
        qty =
          this.bestPrice.requestedQuantity > 0
            ? this.bestPrice.requestedQuantity
            : this.bestPrice.initialQuantity;
      }
      return qty;
    },
    savingsInPercent() {
      if (
        this.bestPrice &&
        this.bestPrice.price &&
        this.bestPrice.price.savingsInformation &&
        this.bestPrice.price.savingsInformation.savingsInPercent
      ) {
        return this.$dict.get('online-Shop.Product.Savings', [
          this.bestPrice.price.savingsInformation.savingsInPercent,
        ]);
      }

      if (this.resultPriceRowsSavings) {
        const activeSaving = this.resultPriceRowsSavings.find((el) => el.active);
        const value =
          activeSaving &&
          activeSaving.savingsInformation &&
          activeSaving.savingsInformation.savingsInPercent;
        if (value) {
          return this.$dict.get('online-Shop.Product.Price-Rows-Saving-Label', [value]);
        }
      }

      return null;
    },
    resultPriceRowsSavings() {
      if (this.bestPrice) {
        let activeIndex = 0;
        const savings = [
          {
            ...this.bestPrice.price,
            minQty: this.bestPrice.initialQuantity,
            savingsInformation: null,
          },
          ...(this.bestPrice.priceRowsIncludingSavings || []),
        ];

        savings.forEach((saving, index) => {
          saving.active = false;

          if (saving.minQty <= this.quantity) {
            activeIndex = index;
          }
        });

        savings[activeIndex].active = true;

        return savings;
      }

      return null;
    },
  },
};
</script>

<style scoped src="./price-savings-in-percent-fi" />
